import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const eLabelImporterSelectors = importerSelectors(
  'eLabel.importer',
);

export default eLabelImporterSelectors;
